import { globalMessageHandler } from "common";

export default function inDev() {
  globalMessageHandler.warningModal("Under development.");
}
